import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyC8Scm5LQ0zzkyUIKqmm94PjSvzf53S844",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    "in-house-dev-mlc.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "in-house-dev-mlc",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    "mlc-bug-tracking-attachments",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "603286827661",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:603286827661:web:076d9b40977028f05b68c4",
};

// Initialize Firebase App singleton
export const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Auth setup
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// Enforce Google Workspace hosted domain hint on client
googleProvider.setCustomParameters({
  hd: "mlconnections.com",
  prompt: "select_account",
});

// CRITICAL: Explicitly connect to the named Firestore database
const firestoreDbName =
  import.meta.env.VITE_FIRESTORE_DB_NAME || "mlc-bug-tracking-db";
export const db = getFirestore(app, firestoreDbName);

// CRITICAL: Explicitly connect to the isolated storage bucket
const storageBucketName =
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
  "mlc-bug-tracking-attachments";
export const storage = getStorage(app, `gs://${storageBucketName}`);
